exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card[data-v-ac1b8a84]{box-shadow:0 2px 4px rgba(0,0,0,.1)}.card-header[data-v-ac1b8a84]{padding:.75rem 1rem}.card-header h5[data-v-ac1b8a84],.card-header h6[data-v-ac1b8a84]{margin-bottom:0}.ml-3[data-v-ac1b8a84]{margin-left:1.5rem!important}.table-sm td[data-v-ac1b8a84],.table-sm th[data-v-ac1b8a84]{padding:.4rem;vertical-align:middle}.badge[data-v-ac1b8a84]{font-size:.85em}.readonly-field[data-v-ac1b8a84]{background-color:#e9ecef!important;cursor:not-allowed}.summary-box[data-v-ac1b8a84]{font-size:.9rem;margin-top:1.5rem}.summary-box .d-flex[data-v-ac1b8a84]{padding:.25rem 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-ac1b8a84","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/BudgetPlan/BudgetPlanCreate.vue
// module id = 1089
// module chunks = 0